module.exports = ""


//////////////////
// WEBPACK FOOTER
// /app/wiserisk-core/src/main/ng4app/src/app/pages/organization/organization.component.html
// module id = ../../../../../src/app/pages/organization/organization.component.html
// module chunks = main